import { SheetData } from "x-data-spreadsheet";

export const ContributionTimeColumnSingleSampleData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Account" }, 1: { text: "Sum of Value" } } },
        1: { cells: { 0: { text: "EBIT 2018" }, 1: { text: "42807" } } },
        2: { cells: { 0: { text: "Revenue" }, 1: { text: "16528" } } },
        3: { cells: { 0: { text: "Other op. income" }, 1: { text: "1990" } } },
        4: { cells: { 0: { text: "Material" }, 1: { text: "12030" } } },
        5: { cells: { 0: { text: "Personnel" }, 1: { text: "7498" } } },
        6: { cells: { 0: { text: "Freight" }, 1: { text: "-1341" } } },
        7: { cells: { 0: { text: "Advertising" }, 1: { text: "262" } } },
        8: { cells: { 0: { text: "Other OpEx" }, 1: { text: "-5836" } } },
        9: { cells: { 0: { text: "Depreciation" }, 1: { text: "-2095" } } },
        10: { cells: { 0: { text: "Financial result" }, 1: { text: "-620" } } },
        11: { cells: { 0: { text: "EBIT 2019" }, 1: { text: "50187" } } },
        12: { cells: { 0: { text: "FX change" }, 1: { text: "-1555" } } },
        13: { cells: { 0: { text: "EBIT FX'" }, 1: { text: "48632" } } },
    },
};

export const ContributionTimeColumnSingleCommentData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Comments" } } },
        2: {
            cells: {
                0: {
                    text: "Sales revenue growth achieved by additional account managers and successful AdWords marketing campaign.",
                },
            },
        },
        4: {
            cells: { 0: { text: "Material costs increased by 12K USD due to higher price of copper." } },
        },
        5: {
            cells: { 0: { text: "Personnel costs have increased because of the 8% FTE growth in the sales department." } },
        },
    },
};

export const ContributionTimeColumnSampleData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Month" }, 1: { text: "AC" }, 2: { text: "PY" } } },
        1: { cells: { 0: { text: "Jan" }, 1: { text: "138" }, 2: { text: "155" } } },
        2: { cells: { 0: { text: "Feb" }, 1: { text: "150" }, 2: { text: "160" } } },
        3: { cells: { 0: { text: "Mar" }, 1: { text: "170" }, 2: { text: "150" } } },
        4: { cells: { 0: { text: "Apr" }, 1: { text: "168" }, 2: { text: "160" } } },
        5: { cells: { 0: { text: "May" }, 1: { text: "140" }, 2: { text: "170" } } },
        6: { cells: { 0: { text: "Jun" }, 1: { text: "130" }, 2: { text: "165" } } },
        7: { cells: { 0: { text: "Jul" }, 1: { text: "120" }, 2: { text: "162" } } },
        8: { cells: { 0: { text: "Aug" }, 1: { text: "122" }, 2: { text: "150" } } },
        9: { cells: { 0: { text: "Sep" }, 1: { text: "125" }, 2: { text: "145" } } },
        10: { cells: { 0: { text: "Oct" }, 1: { text: "156" }, 2: { text: "145" } } },
        11: { cells: { 0: { text: "Nov" }, 1: { text: "182" }, 2: { text: "150" } } },
        12: { cells: { 0: { text: "Dec" }, 1: { text: "200" }, 2: { text: "170" } } },
    },
};

export const ContributionTimeColumnCommentData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Comments" } } },
        1: {
            cells: {
                0: {
                    text: "Seasonality disrupted due to Asian market lockdown. YTD plan expected to be achieved by May.",
                },
            },
        },
        7: {
            cells: {
                0: {
                    text: "Production site #5 out of order due to natural disaster. Estimated repair time in late Oct. Evaluate alternative sites to meet the demand.",
                },
            },
        },
        10: {
            cells: { 0: { text: "Production site #5 re-built and in full capacity." } },
        },
    },
};

export const ContributionStructureBarSampleData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Fruit" }, 1: { text: "AC" }, 2: { text: "PY" } } },
        1: { cells: { 0: { text: "Oranges" }, 1: { text: "170" }, 2: { text: "150" } } },
        2: { cells: { 0: { text: "Lemons" }, 1: { text: "168" }, 2: { text: "160" } } },
        3: { cells: { 0: { text: "Bananas" }, 1: { text: "150" }, 2: { text: "160" } } },
        4: { cells: { 0: { text: "Kiwi" }, 1: { text: "140" }, 2: { text: "170" } } },
        5: { cells: { 0: { text: "Apples" }, 1: { text: "138" }, 2: { text: "155" } } },
        6: { cells: { 0: { text: "Melons" }, 1: { text: "145" }, 2: { text: "160" } } },
        7: { cells: { 0: { text: "Pears" }, 1: { text: "120" }, 2: { text: "110" } } },
        8: { cells: { 0: { text: "Grapes" }, 1: { text: "110" }, 2: { text: "105" } } },
    },
};

export const ContributionStackedWaterfallSampleData: SheetData = {
    rows: {
        0: {
            cells: {
                0: { text: "Category" },
                1: { text: "Germany" },
                2: { text: "United States" },
                3: { text: "Japan" },
                4: { text: "United Kingdom" },
                5: { text: "France" },
            },
        },
        1: {
            cells: {
                0: { text: "EBITDA PY" },
                1: { text: "8809000" },
                2: { text: "6500000" },
                3: { text: "3240000" },
                4: { text: "4120000" },
                5: { text: "2760000" },
            },
        },
        2: {
            cells: {
                0: { text: "Revenue" },
                1: { text: "-2432000" },
                2: { text: "-1500000" },
                3: { text: "860000" },
                4: { text: "-980000" },
                5: { text: "540000" },
            },
        },
        3: {
            cells: {
                0: { text: "COGS" },
                1: { text: "1432000" },
                2: { text: "500000" },
                3: { text: "310000" },
                4: { text: "640000" },
                5: { text: "415000" },
            },
        },
        4: {
            cells: {
                0: { text: "Restructuring" },
                1: { text: "747000" },
                2: { text: "500000" },
                3: { text: "180000" },
                4: { text: "310000" },
                5: { text: "220000" },
            },
        },
        5: {
            cells: {
                0: { text: "Adj. EBITDA PY 1" },
                1: { text: "8556000" },
                2: { text: "6000000" },
                3: { text: "4590000" },
                4: { text: "4090000" },
                5: { text: "3935000" },
            },
        },
        6: {
            cells: {
                0: { text: "Inventory devaluation" },
                1: { text: "-64000" },
                2: { text: "-200000" },
                3: { text: "-128000" },
                4: { text: "-85000" },
                5: { text: "-52000" },
            },
        },
        7: {
            cells: {
                0: { text: "Adj. EBITDA PY 2" },
                1: { text: "8492000" },
                2: { text: "5800000" },
                3: { text: "4462000" },
                4: { text: "4005000" },
                5: { text: "3883000" },
            },
        },
        8: {
            cells: {
                0: { text: "New business" },
                1: { text: "540000" },
                2: { text: "920000" },
                3: { text: "1240000" },
                4: { text: "690000" },
                5: { text: "430000" },
            },
        },
        9: {
            cells: {
                0: { text: "Growth core business" },
                1: { text: "1190000" },
                2: { text: "1400000" },
                3: { text: "2050000" },
                4: { text: "880000" },
                5: { text: "760000" },
            },
        },
        10: {
            cells: {
                0: { text: "Additional headcount" },
                1: { text: "-111000" },
                2: { text: "-50000" },
                3: { text: "-390000" },
                4: { text: "-145000" },
                5: { text: "-95000" },
            },
        },
        11: {
            cells: {
                0: { text: "EBITDA AC" },
                1: { text: "10111000" },
                2: { text: "8070000" },
                3: { text: "7362000" },
                4: { text: "5430000" },
                5: { text: "4978000" },
            },
        },
    },
};

export const ContributionLayeredWaterfallSampleData: SheetData = {
    rows: {
        0: {
            cells: {
                0: { text: "P&L Item" },
                1: { text: "Enterprise Software" },
                2: { text: "Manufacturing" },
                3: { text: "Retail Services" },
                4: { text: "Healthcare" },
                5: { text: "Financial Services" },
            },
        },
        1: {
            cells: {
                0: { text: "EBITDA" },
                1: { text: "186.40" },
                2: { text: "244.80" },
                3: { text: "97.30" },
                4: { text: "142.50" },
                5: { text: "118.90" },
            },
        },
        2: {
            cells: {
                0: { text: "D&A" },
                1: { text: "-12.70" },
                2: { text: "-58.20" },
                3: { text: "-21.60" },
                4: { text: "-33.40" },
                5: { text: "-8.40" },
            },
        },
        3: {
            cells: {
                0: { text: "EBIT" },
                1: { text: "173.70" },
                2: { text: "186.60" },
                3: { text: "75.70" },
                4: { text: "109.10" },
                5: { text: "110.50" },
            },
        },
        4: {
            cells: {
                0: { text: "Interest Expense" },
                1: { text: "-4.10" },
                2: { text: "-21.50" },
                3: { text: "-9.80" },
                4: { text: "-8.60" },
                5: { text: "-14.30" },
            },
        },
        5: {
            cells: {
                0: { text: "Tax" },
                1: { text: "-31.80" },
                2: { text: "-28.90" },
                3: { text: "-12.40" },
                4: { text: "-22.70" },
                5: { text: "-19.60" },
            },
        },
        6: {
            cells: {
                0: { text: "Net Earnings" },
                1: { text: "137.80" },
                2: { text: "136.20" },
                3: { text: "53.50" },
                4: { text: "77.80" },
                5: { text: "76.60" },
            },
        },
        7: {
            cells: {
                0: { text: "D&A (add back)" },
                1: { text: "12.70" },
                2: { text: "58.20" },
                3: { text: "21.60" },
                4: { text: "33.40" },
                5: { text: "8.40" },
            },
        },
        8: {
            cells: {
                0: { text: "CapEx" },
                1: { text: "-9.30" },
                2: { text: "-62.40" },
                3: { text: "-24.70" },
                4: { text: "-37.90" },
                5: { text: "-6.70" },
            },
        },
        9: {
            cells: {
                0: { text: "Delta Net Working Capital" },
                1: { text: "-3.60" },
                2: { text: "-11.20" },
                3: { text: "-6.80" },
                4: { text: "-5.20" },
                5: { text: "2.90" },
            },
        },
        10: {
            cells: {
                0: { text: "Free Cash Flow" },
                1: { text: "137.60" },
                2: { text: "120.80" },
                3: { text: "43.60" },
                4: { text: "68.10" },
                5: { text: "81.20" },
            },
        },
    },
};

export const ContributionStructureBarCommentData: SheetData = {
    rows: {
        0: { cells: { 0: { text: "Comments" } } },
        1: {
            cells: {
                0: {
                    text: "Oranges volume will be increased in the next quarter. Contracts signed with new suppliers in Southern Europe to meet the increased demand.",
                },
            },
        },
        3: { cells: { 0: { text: "South American supply has dropped by 10% due to a temporary export ban." } } },
        8: {
            cells: {
                0: { text: "The demand is gradually increasing just before spring/summer season. Evaluate new suppliers." },
            },
        },
    },
};
